<template>
  <div class="electrolytic-cell-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>电解：电能 → 化学能</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Vats (Container) -->
          <rect x="80" y="80" width="240" height="140" fill="rgba(0, 111, 253, 0.1)" stroke="#555" />
          <line x1="80" y1="100" x2="320" y2="100" stroke="rgba(255,255,255,0.2)" /> <!-- Liquid Surface -->

          <!-- Electrodes -->
          <rect x="120" y="40" width="15" height="140" :fill="powerOn ? '#ff4757' : '#888'" />
          <text x="110" y="30" fill="#ff4757" font-size="10" v-if="powerOn">阳极 (+)</text>
          
          <rect x="265" y="40" width="15" height="140" :fill="powerOn ? '#2ed573' : '#888'" />
          <text x="255" y="30" fill="#2ed573" font-size="10" v-if="powerOn">阴极 (-)</text>

          <!-- Ions and Electrons -->
          <g v-if="powerOn">
             <!-- Anions moving to Anode -->
             <circle v-for="n in 5" :key="'an'+n" :cx="150 + n*20" :cy="150" r="4" fill="#ff4757" opacity="0.6">
                <animate attributeName="cx" to="135" dur="1s" repeatCount="indefinite" />
             </circle>
             <!-- Cations moving to Cathode -->
             <circle v-for="n in 5" :key="'ca'+n" :cx="150 + n*20" :cy="180" r="4" fill="#2ed573" opacity="0.6">
                <animate attributeName="cx" to="265" dur="1.2s" repeatCount="indefinite" />
             </circle>
             <!-- Bubbles -->
             <circle v-for="n in 6" :key="'b'+n" :cx="127" :cy="170 - n*15" r="3" fill="none" stroke="#fff" opacity="0.4">
                <animate attributeName="cy" from="170" to="100" dur="2s" repeatCount="indefinite" />
             </circle>
          </g>

          <!-- External Circuit -->
          <path d="M 127 40 L 127 20 L 272 20 L 272 40" fill="none" stroke="#888" stroke-dasharray="4" />
          <circle cx="200" cy="20" r="8" :fill="powerOn ? '#ffd700' : '#333'" />
          <text x="215" y="25" fill="#888" font-size="8">直流电源</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电解质溶液导电过程</label>
              <div class="value">就是化学反应过程</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <el-button :type="powerOn ? 'danger' : 'success'" size="mini" @click="powerOn = !powerOn">
               {{ powerOn ? '停止电解' : '开启电源' }}
             </el-button>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>电解池将**电能转化为化学能**。在外部电压的作用下，阴阳离子各向极板定向移动。阳极发生氧化反应，阴极发生还原反应。这是工业制铝、提纯金属和电解水产生氢气的基本原理。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElectrolyticCellViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      powerOn: true
    }
  }
}
</script>

<style scoped lang="scss">
.electrolytic-cell-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(0, 111, 253, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
